// src/stores/progressStore.ts
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ReadingProgress {
  postId: string;
  readTime: number;
  lastRead: Date;
  isUnlocked: boolean;
}

interface ProgressState {
  progress: Record<string, ReadingProgress>;
  updateProgress: (postId: string, data: Partial<ReadingProgress>) => void;
  isUnlocked: (postId: string) => boolean;
}

export const useProgressStore = create<ProgressState>()(
  persist(
    (set, get) => ({
      progress: {},
      updateProgress: (postId, data) => set((state) => ({
        progress: {
          ...state.progress,
          [postId]: {
            ...state.progress[postId],
            ...data,
            lastRead: new Date(),
          },
        },
      })),
      isUnlocked: (postId) => {
        const progress = get().progress[postId];
        return progress?.isUnlocked || false;
      },
    }),
    {
      name: 'blog-progress',
    }
  )
);